import { PortalMenu } from '@/msgComponents/PortalMenu/PortalMenu'
import type { PortalMenuConfig } from '@/msgComponents/PortalMenu/types'

// Surface-owned vocabulary for the reusable portal menu. Other surfaces can
// mount the same menu with their own labels without forking its behavior,
// legacy contracts, layout, or styling.
const stdMenuConfig: PortalMenuConfig = Object.freeze({
  labels: Object.freeze({
    brand: 'Msgdesk',
    reply: 'Reply',
    edit: 'Edit',
    editThisMessageTitle: 'Edit this message',
    newMessage: 'New msg',
    save: 'Save',
    saveChanges: 'Save changes',
    saveMessage: 'Save msg',
    saveAnswer: 'Save answer',
    backToMain: 'My personal page',
    parents: 'Parents',
    parentsHome: 'Msgdesk.com',
    answers: 'Answers',
    messages: 'Messages',
    attachments: 'Attachments',
    bookmarks: 'Bookmarks',
    drafts: 'Drafts',
    trash: 'Basket',
    folderAnswers: 'Answers',
    folderMessages: 'Msges',
    help: 'Help',
  }),
  helpHref: 'answer.hb5umipoxlaji',
})

export function StdMenu({ isEditorOpen = false }: { isEditorOpen?: boolean }) {
  return <PortalMenu isEditorOpen={isEditorOpen} config={stdMenuConfig} />
}
